import { logger } from '@adornis/base/logging.js';
import { getGlobalConfig } from '@adornis/bh-matching-config/entities/global-config.js';
import type { TranslationDictionaryBuddy } from '@adornis/bh-matching-translation/translations.js';
import { TrDialog } from '@adornis/buchungsheld-theme/components/tr-dialog.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/chemistry/elements/components/x-flex';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
import { FormController } from '@adornis/forms/x-form-controller.js';
import { goTo } from '@adornis/router/client/open-href.js';
import '@adornis/tiptap/client/x-tiptap';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

/*
 * @element buddy-page-admin-legal-pages
 */
@customElement('buddy-page-admin-legal-pages')
export class BuddyPageAdminLegalPages extends ChemistryLitElement {
  @state() private readonly _translation = new TranslationController<TranslationDictionaryBuddy>(this);
  @state() private readonly _config = new RXController(this, getGlobalConfig()({ imprint: 1, dataPrivacy: 1 }));
  @state() private readonly _form = new FormController(this, this._config.observable, {
    success: async config => {
      try {
        await TrDialog.waitFor(config.save());
        void XSnackbar.show('Impressum und Datenschutz wurden erfolgreich gespeichert.');
      } catch (err) {
        logger.error({ err });
        void TrDialog.alert(
          'Es gab ein Problem beim Speichern des Datenschutzes und des Impressums. Bitte versuchen Sie es später erneut.',
        );
      }
    },
  });

  override render() {
    return html`
      <x-flex space="lg">
        <bh-breadcrumb .goUp=${() => goTo('/')}></bh-breadcrumb>
        <x-flex space="sm">
          <x-text bold> ${this._translation.translate('imprint')} </x-text>
          <x-tiptap ${this._form.field('imprint')}></x-tiptap>
        </x-flex>
        <x-flex space="sm">
          <x-text bold> ${this._translation.translate('privacy')} </x-text>
          <x-tiptap ${this._form.field('dataPrivacy')}></x-tiptap>
        </x-flex>
        <x-flex horizontal end>
          <x-button icon="save" @click=${(e: MouseEvent) => this._form.validate({ mouseEvent: e })}>
            ${this._translation.translate('save')}
          </x-button>
        </x-flex>
      </x-flex>
    `;
  }
}
